//It is better to put this array outside the main component.
export const months = [
  ["Janvier", "Janv"], //[["name","shortName"], ... ]
  ["Février", "Févr"],
  ["Mars", "Mars"],
  ["Avril", "Avr"],
  ["Mai", "Mai"],
  ["Juin", "Juin"],
  ["Juillet", "Juil"],
  ["Août", "Août"],
  ["Septembre", "Sept"],
  ["Octobre", "Oct"],
  ["Novembre", "Nov"],
  ["Décembre", "Déc"],
]
export const weekDays = [
  ["Dimanche", "Dim"], //[["name","shortName"], ... ]
  ["Lundi", "Lun"],
  ["Mardi", "Mar"],
  ["Mercredi", "Mer"],
  ["Jeudi", "Jeu"],
  ["Vendredi", "Ven"],
  ["Samedi", "Sam"],
]